import { createFileRoute } from '@tanstack/react-router';
import { DeveloperManualPage } from '@/components/marketing/DeveloperManualPage';
import { MarketingShell } from '@/components/marketing/MarketingShell';

/**
 * `/developers` — Slice G. API pública dev-facing.
 *
 * Originalmente vivía en `/api` pero ese path choca con el proxy Vite que
 * redirige `/api/**` al backend Functions (TenantManagement). NO confundir
 * con `/api-docs` que es la Scalar UI interna del portal (slice
 * `_authenticated.api-docs.tsx`).
 */
export const Route = createFileRoute('/_public/developers')({
  component: PublicApiRoute,
});

function PublicApiRoute(): JSX.Element {
  return (
    <MarketingShell currentPath="/developers">
      <DeveloperManualPage />
    </MarketingShell>
  );
}
